import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import MBankLogo from 'shared/icons/mbank.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const MbankInstallment = () => {
  const { t } = useTranslation()
  return (
    <div className={s.mbankInstallment}>
      <ImageLazy
        alt=""
        src={MBankLogo}
        className={s.logo}
      />

      <div className={s.text}>
        <h4 className={clsx(s.title, 'semi-bold-15')}>
          {t('mplus.installment_three_month')}
        </h4>
        <p className={clsx(s.description, 'regular-15')}>
          {t('mplus.from_mbank')}
        </p>
      </div>
    </div>
  )
}
